'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiHome = function TiHome(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 5s-10.3 8.9-16.1 13.7c-0.3 0.3-0.6 0.8-0.6 1.3 0 0.9 0.8 1.7 1.7 1.7h3.3v11.6c0 1 0.8 1.7 1.7 1.7h5c0.9 0 1.7-0.7 1.7-1.7v-6.6h6.6v6.6c0 1 0.8 1.7 1.7 1.7h5c0.9 0 1.7-0.7 1.7-1.7v-11.6h3.3c0.9 0 1.7-0.8 1.7-1.7 0-0.5-0.3-1-0.7-1.3-5.7-4.8-16-13.7-16-13.7z' })
        )
    );
};

exports.default = TiHome;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/home.js
// module id = 2080
// module chunks = 0